/**
 * Forma de los documentos legales y los datos de la página de eliminación de
 * cuenta que **no dependen del idioma**.
 *
 * El texto de los cinco documentos vive en `src/i18n/locales/<idioma>/legal.ts`.
 * Aquí quedan las interfaces y los datos que sería un error traducir: una
 * dirección de correo y el nombre del responsable son los mismos en cualquier
 * idioma, y duplicarlos por idioma solo abre la puerta a que diverjan.
 */

export interface LegalSection {
  title: string;
  /** Párrafos del apartado. Se renderizan como <p> separados. */
  paragraphs: string[];
}

export interface LegalDocument {
  /** Título del documento, usado como <h1> y en <title>. */
  title: string;
  /** Línea de vigencia mostrada arriba del contenido. */
  effectiveNote: string;
  /** Párrafos introductorios antes del primer apartado numerado. */
  intro: string[];
  sections: LegalSection[];
}

export interface DataRetentionRow {
  /** Identificador estable de la fila (clave de React). */
  id: string;
  /** Qué se elimina/anonimiza. */
  deleted: string;
  /** Qué se conserva. */
  retained: string;
  /** Por qué se conserva (razón legal/operativa). */
  reason: string;
}

/**
 * TODO: confirma que este correo es el que el equipo realmente monitorea
 * para solicitudes de eliminación de cuenta. Lo tomé de la Política de
 * Privacidad ya publicada en este mismo sitio (apartados 8 y 11:
 * "escribiendo a privacidad@barbunny.com"), no lo inventé — pero
 * confírmalo, porque esa política nombra a "Bar Bunny S.A. de C.V." como
 * responsable, y el pedido de esta página fue identificar a Ilumetria (ver
 * comentario de ACCOUNT_DELETION_ENTITY abajo). Si son entidades distintas,
 * puede que el correo de contacto también deba ser otro.
 */
export const ACCOUNT_DELETION_EMAIL = 'privacidad@barbunny.com';

/**
 * TODO: verifica el nombre legal exacto y cualquier dato adicional
 * (RFC, domicilio fiscal) que Ilumetria quiera mostrar aquí como
 * responsable del tratamiento. No inventé razón social ni domicilio.
 */
export const ACCOUNT_DELETION_ENTITY = 'Ilumetria';

/**
 * Nota sobre el plazo de la eliminación EN LA APP (no un TODO — esto sí se
 * pudo verificar en código): el endpoint que dispara la eliminación
 * (`DELETE /auth/account`) es síncrono — no encola un job ni un proceso
 * diferido, la anonimización ocurre en la misma petición. Es decir, la
 * eliminación dentro de la app es inmediata.
 */
export const inAppDeletionIsImmediate = true;
